<template>
  <v-app>
      <PageLoader/>
      <v-main class="body">     
          <Navbar v-if="!isAdminPage"/>
          <div v-if="!isAdminPage" :style="$vuetify.breakpoint.mdAndUp ? 'height:7.5rem':'height:4.5rem'"></div>
           <v-fade-transition
              leave-absolute
              hide-on-leave
            >
          <router-view/>
             </v-fade-transition>      
      
      </v-main>
      <Footer class="footer" v-if="!isAdminPage && $vuetify.breakpoint.lgAndUp"/>
      <Mfooter class="footer" v-else-if="!isAdminPage"/>
  </v-app>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import Mfooter from '@/components/Mfooter.vue'
import PageLoader from '@/views/PageLoader.vue'
export default {
  name: 'App',
  state: false,
  components:{
    Navbar,
    Footer,
    Mfooter,
    PageLoader
  },
  computed:{
    isAdminPage: function(){
      console.log(this.$route.path);
      return this.$route.path == '/admin' || this.$route.path == '/dashboard';
    }
  }
};
</script>
<style>
  .body{
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

</style>
